import { IconButton, Tooltip } from '@mui/material'
import React from 'react'

// process tooltip and disabled props
function TableActions({ row, actions }) {
  return (
    <div>
      {actions.map((action, index) => {
        const isDisabled = typeof action.disabled === 'function'
          ? action.disabled(row.original)
          : Boolean(action.disabled);
        const tooltipText = typeof action.tooltip === 'function'
          ? action.tooltip(row.original)
          : (action.tooltip || '');

        return isDisabled ? <div key={index}></div> : (
          <Tooltip key={index} title={tooltipText} arrow>
            <IconButton onClick={(event) => action.onClick(row.original)}>
              {action.icon}
            </IconButton>
          </Tooltip>
        );
      })}
    </div>
  )
}

export default TableActions